import { Stack } from 'component-library';
import { useEffect, useState } from 'react';

import { IndicatorName } from '@/api/rest/resources/types/fact';
import { ChartDataItem, HabitatConnectivityChart } from '@/components/Charts/HabitatConnectivity';
import { GraphFact } from '@/components/Charts/types';
import { GraphTileProps } from '@/components/IndicatorCard/GraphTile';
import { useSetIndicatorHasData } from '@/components/IndicatorCard/IndicatorContextProvider';
import { useOrganizationIndicatorGraphFact } from '@/pages/shared/hooks/useOrganizationFact';
import { NoData } from '@/pages/shared/projects/pages/project/pages/sustainableProduction/components/NoData';
import { isNullish } from '@/utils/booleans';

import { PlotsDialog } from './PlotsDialog';

export const HabitatConnectivityGraphTile = ({
  plotGroupId,
}: Partial<GraphTileProps & { selectedBenchmark?: string | null }>) => {
  const { setIndicatorGraphData } = useSetIndicatorHasData();
  const [selectedItem, setSelectedItem] = useState<ChartDataItem | null>(null);

  const { [IndicatorName.structural_integrity_benchmark_graph]: benchmarkGraphFact } =
    useOrganizationIndicatorGraphFact<GraphFact[]>(
      IndicatorName.structural_integrity_benchmark_graph,
      null,
      undefined,
      plotGroupId,
    );

  const chartData = benchmarkGraphFact?.value;
  const noChartData = isNullish(chartData) || chartData.length === 0;

  useEffect(() => {
    setIndicatorGraphData({ graphData: !noChartData });
  }, [noChartData, setIndicatorGraphData]);

  if (noChartData) {
    return <NoData />;
  }

  return (
    <Stack center data-testid='habitat-connectivity-graph-tile'>
      <Stack spacing={2.5} className='w-full items-center justify-center px-1 py-6 lg:items-start lg:p-8 lg:pl-1'>
        <HabitatConnectivityChart data={chartData} onBarClick={setSelectedItem} />
      </Stack>
      {selectedItem && (
        <PlotsDialog
          open={!!selectedItem}
          onOpenChange={(open) => {
            if (!open) {
              setSelectedItem(null);
            }
          }}
          label={selectedItem.label}
          plots={selectedItem.plots}
        />
      )}
    </Stack>
  );
};
